export default class UnifiedSignupPersonaDetails {
  public readonly personaDetails;

  public static productDesignerOrEngineer = new UnifiedSignupPersonaDetails({
    val: 'Product Designer / Engineer',
  });

  public static managerOrExecutive = new UnifiedSignupPersonaDetails({
    val: 'Manager or Executive',
  });

  public static cadOrPdmAdmin = new UnifiedSignupPersonaDetails({
    val: 'CAD or PDM Administrator',
  });

  public static startingNewBusiness = new UnifiedSignupPersonaDetails({
    val: 'Starting a New Business',
  });

  public static hobbyist = new UnifiedSignupPersonaDetails({ val: 'Hobbyist' });

  public static student = new UnifiedSignupPersonaDetails({ val: 'Student' });

  public static educator = new UnifiedSignupPersonaDetails({ val: 'Educator' });

  public static newToCad = new UnifiedSignupPersonaDetails({ val: 'New to CAD' });

  public static other = new UnifiedSignupPersonaDetails({ val: 'Other' });

  private static mappings: Record<string, UnifiedSignupPersonaDetails> = {
    'Product Designer / Engineer': UnifiedSignupPersonaDetails.productDesignerOrEngineer,
    'Manager or Executive': UnifiedSignupPersonaDetails.managerOrExecutive,
    'CAD or PDM Administrator': UnifiedSignupPersonaDetails.cadOrPdmAdmin,
    'Starting a New Business': UnifiedSignupPersonaDetails.startingNewBusiness,
    Hobbyist: UnifiedSignupPersonaDetails.hobbyist,
    Student: UnifiedSignupPersonaDetails.student,
    Educator: UnifiedSignupPersonaDetails.educator,
    'New to CAD': UnifiedSignupPersonaDetails.newToCad,
    Other: UnifiedSignupPersonaDetails.other,
  };

  private constructor({ val }: { val: string }) {
    this.personaDetails = val;
  }

  public static fromString(val: string | number | boolean): UnifiedSignupPersonaDetails {
    const personaDetails = UnifiedSignupPersonaDetails.mappings[`${val}`];
    if (!personaDetails) throw new Error(`Could not find persona details with val: '${val}'`);
    return personaDetails;
  }

  public compareTo(rhs: UnifiedSignupPersonaDetails) {
    return this.personaDetails === rhs.personaDetails;
  }
}
